export default __webpack_public_path__ + "b7eb9af46b9ce2ab6e4c90f1ba1f04d2.svg";